import React, { FC, useEffect } from 'react'
import _ from 'lodash'
// types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_settings'
const displayName = 'Folder Settings'

type FolderReportParameters = ReportFormParameters & {
  report: ReportType
}

const FolderSettings: FC<FolderReportProps> = (props) => {
  useEffect(() => {
    props.setParameters(getParameters())
    props.setValid(true)
  }, [])

  function getParameters(): FolderReportParameters {
    return {
      report: 'folder_settings'
    }
  }

  return <></>
}

FolderSettings.displayName = displayName
export default FolderSettings
